import { connect } from 'react-redux';

import Search from './Search';
import { rootPageUri } from '../../config/uri';
import {getSelectedCustomerType, isStrictMedicalCustomerType} from '../../selectors/customer_type_selector';
import { getSecondaryColor } from '../../selectors/configSelectors';
import { getSalesChannelName } from '../../selectors/sales_channel_selectors';
import { pushWithQueryParams } from '../../services/uri';

const mapStateToProps = (state) => {
  return {
    customerType: getSelectedCustomerType(state),
    secondaryColor: getSecondaryColor(state),
    salesChannelName: getSalesChannelName(state),
    strictMedicalCustomerType: isStrictMedicalCustomerType(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    goBack: () => dispatch(pushWithQueryParams(rootPageUri)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Search);



// WEBPACK FOOTER //
// ./src/components/Search/search_container.jsx